import * as React from 'react';
import cx from 'classnames';
import styles from './CartActionButton.css';
import StringWidget, { isStringTemplateKey } from 'components/StringWidget/StringWidget';
import { isEmpty } from 'lodash';
export default function CartActionButton(props) {
    const { buttons, isMarketPlace, className, isBasket } = props;
    if (isEmpty(buttons))
        return null;
    return (<div className={cx(className, styles['cart-item-buttons'], { [styles['not-market-place']]: !isMarketPlace }, { [styles['market-place']]: isMarketPlace })}>
			{buttons.map((button, key) => {
        if (isEmpty(button))
            return null;
        const { onClick, tabIndex, tag, buttonText, buttonStyle } = button;
        return (<div key={key} className={cx(styles['cart-item-button'], buttonStyle, { [styles['basket-button']]: isBasket })} onClick={onClick} tabIndex={tabIndex} data-aid={tag}>
						{isStringTemplateKey(buttonText) ? <StringWidget strKey={buttonText}/> : buttonText}
					</div>);
    })}
		</div>);
}
